var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsLineIntegrations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apps-line-integrations"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16658 5.62467C9.16658 3.66867 7.58093 2.08301 5.62492 2.08301C3.66891 2.08301 2.08325 3.66867 2.08325 5.62467C2.08325 7.58068 3.66891 9.16634 5.62492 9.16634H9.16658V5.62467ZM7.49992 5.62467V7.49967H5.62492C4.58939 7.49967 3.74992 6.66021 3.74992 5.62467C3.74992 4.58914 4.58939 3.74967 5.62492 3.74967C6.66045 3.74967 7.49992 4.58914 7.49992 5.62467Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16658 10.833H5.62492C3.66891 10.833 2.08325 12.4187 2.08325 14.3747C2.08325 16.3307 3.66891 17.9163 5.62492 17.9163C7.58093 17.9163 9.16658 16.3307 9.16658 14.3747V10.833ZM3.74992 14.3747C3.74992 13.3392 4.58939 12.4997 5.62492 12.4997H7.49992V14.3747C7.49992 15.4102 6.66045 16.2497 5.62492 16.2497C4.58939 16.2497 3.74992 15.4102 3.74992 14.3747Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9166 5.62467C17.9166 3.66867 16.3309 2.08301 14.3749 2.08301C12.4189 2.08301 10.8333 3.66867 10.8333 5.62467V9.16634H14.3749C16.3309 9.16634 17.9166 7.58068 17.9166 5.62467ZM16.2499 5.62467C16.2499 6.66021 15.4104 7.49967 14.3749 7.49967H12.4999V5.62467C12.4999 4.58914 13.3394 3.74967 14.3749 3.74967C15.4104 3.74967 16.2499 4.58914 16.2499 5.62467Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3338V10.8338H14.9999V13.3338H17.4999V15.0005H14.9999V17.5005H13.3333V15.0005H10.8333V13.3338H13.3333Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsLineIntegrations);
export default __webpack_public_path__ + "static/media/apps-line-integrations.7a6654ce3a2e622e21ea7bd373b75229.svg";
export { ForwardRef as ReactComponent };